import React from 'react';
import { MessageSquareIcon, AlertTriangleIcon, RefreshCwIcon, ArrowLeftIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen17_FullReview({
  onBack,
  onNext
}: ScreenProps) {
  return <div className="flex flex-col h-full" data-id="element-651">
      <div className="mb-6" data-id="element-652">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-653">Meeting Review</h2>
        <p className="text-slate-400" data-id="element-654">
          Complete AI audit of the safety briefing.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-8" data-id="element-655">
        {/* Meeting Overview */}
        <section data-id="element-656">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-657">
            Meeting Overview
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 grid grid-cols-2 gap-y-4 gap-x-2" data-id="element-658">
            <div data-id="element-659">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-660">
                Meeting Type
              </p>
              <p className="text-white font-medium text-sm" data-id="element-661">
                PTP Safety Briefing
              </p>
            </div>
            <div data-id="element-662">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-663">
                Duration
              </p>
              <p className="text-white font-medium text-sm" data-id="element-664">04:36</p>
            </div>
            <div data-id="element-665">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-666">
                Recorded By
              </p>
              <p className="text-white font-medium text-sm" data-id="element-667">Foreman</p>
            </div>
            <div data-id="element-668">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-669">
                Project
              </p>
              <p className="text-white font-medium text-sm" data-id="element-670">
                Downtown Office Tower
              </p>
            </div>
            <div className="col-span-2" data-id="element-671">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-672">
                Location
              </p>
              <p className="text-white font-medium text-sm" data-id="element-673">
                Level 2 Structural Frame
              </p>
            </div>
          </div>
        </section>

        {/* Participants */}
        <section data-id="element-674">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-675">
            Participants
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-id="element-676">
            <ul className="space-y-2 text-sm" data-id="element-677">
              <li className="flex justify-between" data-id="element-678">
                <span className="text-white" data-id="element-679">Foreman</span>
                <span className="text-green-400" data-id="element-680">active</span>
              </li>
              <li className="flex justify-between" data-id="element-681">
                <span className="text-white" data-id="element-682">Crane Operator</span>
                <span className="text-green-400" data-id="element-683">active</span>
              </li>
              <li className="flex justify-between" data-id="element-684">
                <span className="text-white" data-id="element-685">Rigger</span>
                <span className="text-green-400" data-id="element-686">active</span>
              </li>
              <li className="flex justify-between" data-id="element-687">
                <span className="text-white" data-id="element-688">Ironworker</span>
                <span className="text-amber-400" data-id="element-689">limited participation</span>
              </li>
              <li className="flex justify-between" data-id="element-690">
                <span className="text-white" data-id="element-691">Laborer</span>
                <span className="text-amber-400" data-id="element-692">limited participation</span>
              </li>
            </ul>
          </div>
        </section>

        {/* Subjects Covered */}
        <section data-id="element-693">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-694">
            Subjects Covered
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-id="element-695">
            <ul className="space-y-2 text-sm" data-id="element-696">
              {['Task steps and lift sequence', 'Crane setup and outriggers', 'Rigging inspection', 'Lift path to second floor', 'Exclusion zone', 'Signal person assignment', 'Beam positioning'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300" data-id="element-697">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-1.5 flex-shrink-0" data-id="element-698" />
                  {item}
                </li>)}
            </ul>
          </div>
        </section>

        {/* Subjects Missing or Weak */}
        <section data-id="element-699">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-700">
            Subjects Missing or Weak
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-id="element-701">
            <ul className="space-y-2 text-sm" data-id="element-702">
              {['Wind conditions before and during lift', 'Emergency response if beam becomes unstable', 'Full crew PPE confirmation', 'Verbal confirmation from all workers'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300" data-id="element-703">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-1.5 flex-shrink-0" data-id="element-704" />
                  {item}
                </li>)}
            </ul>
          </div>
        </section>

        {/* AI Recommendation */}
        <section data-id="element-705">
          <div className="flex items-center gap-2 mb-3" data-id="element-706">
            <AlertTriangleIcon className="w-5 h-5 text-orange-500" data-id="element-707" />
            <h3 className="text-sm font-bold text-orange-400 uppercase tracking-wider" data-id="element-708">
              AI Recommendation
            </h3>
          </div>
          <div className="bg-orange-500/10 border border-orange-500/30 rounded-xl p-4" data-id="element-709">
            <p className="text-orange-100 text-sm leading-relaxed" data-id="element-710">
              Before work begins, repeat a short follow-up meeting covering wind
              conditions, unstable load response, and crew verbal confirmation.
            </p>
          </div>
        </section>

        {/* Example Transcript Snippets */}
        <section data-id="element-711">
          <div className="flex items-center gap-2 mb-3" data-id="element-712">
            <MessageSquareIcon className="w-5 h-5 text-slate-400" data-id="element-713" />
            <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-714">
              Example Transcript Snippets
            </h3>
          </div>
          <div className="space-y-3" data-id="element-715">
            {[{
            role: 'Foreman',
            text: 'We lifting beams to level two, crane set here, nobody under the load.'
          }, {
            role: 'Crane Operator',
            text: 'If wind comes up too much or beam starts moving, I stop the lift.'
          }, {
            role: 'Rigger',
            text: 'Tag lines on both ends, keep the load controlled.'
          }, {
            role: 'Foreman',
            text: 'Signal person stays clear and radio check before we go.'
          }].map((snippet, i) => <div key={i} className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-id="element-716">
                <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-717">
                  {snippet.role}
                </p>
                <p className="text-slate-300 text-sm italic" data-id="element-718">
                  "{snippet.text}"
                </p>
              </div>)}
          </div>
        </section>

        {/* Meeting Quality Score */}
        <section data-id="element-719">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-720">
            Meeting Quality Score
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 flex items-center gap-4" data-id="element-721">
            <div className="text-3xl font-black text-white" data-id="element-722">
              72<span className="text-lg text-slate-500" data-id="element-723">/100</span>
            </div>
            <div className="h-8 w-px bg-slate-800" data-id="element-724" />
            <div className="text-amber-400 font-bold uppercase tracking-wider text-sm" data-id="element-725">
              Needs Improvement
            </div>
          </div>
        </section>
      </div>

      <div className="pt-4 space-y-3 bg-slate-950" data-id="element-726">
        <PrimaryButton onClick={onNext} icon={<RefreshCwIcon className="w-5 h-5" data-id="element-728" />} data-id="element-727">
          Send Quiz to Crew
        </PrimaryButton>
        <SecondaryButton onClick={onBack} icon={<ArrowLeftIcon className="w-5 h-5" data-id="element-730" />} data-id="element-729">
          Back to PTP
        </SecondaryButton>
      </div>
    </div>;
}